// Mapea el código de país ISO 3166-1 alpha-2 (el que devuelve ipapi.co como
// country_code) al idioma de esa lista de LANGUAGES soportado más hablado en
// ese país. Se usa solo para la detección automática de idioma al primer
// ingreso (ver translateService.autoDetectLanguageByCountry) — países que no
// están acá simplemente no disparan el cambio automático y se quedan con el
// idioma por defecto (español).
export const COUNTRY_LANGUAGE_MAP = {
  // Español
  AR: 'es', ES: 'es', MX: 'es', CO: 'es', PE: 'es', VE: 'es', CL: 'es',
  EC: 'es', GT: 'es', CU: 'es', BO: 'es', DO: 'es', HN: 'es', PY: 'es',
  SV: 'es', NI: 'es', CR: 'es', PA: 'es', UY: 'es', PR: 'es', GQ: 'es',
  // Inglés
  US: 'en', GB: 'en', CA: 'en', AU: 'en', NZ: 'en', IE: 'en',
  // Portugués
  BR: 'pt', PT: 'pt',
  // Francés
  FR: 'fr',
  // Alemán
  DE: 'de', AT: 'de',
  // Italiano
  IT: 'it',
  // Chino
  CN: 'zh', TW: 'zh', HK: 'zh',
  // Japonés
  JP: 'ja',
  // Coreano
  KR: 'ko',
  // Ruso
  RU: 'ru', BY: 'ru',
  // Árabe
  SA: 'ar', AE: 'ar', EG: 'ar', IQ: 'ar', JO: 'ar', KW: 'ar', QA: 'ar',
  OM: 'ar', BH: 'ar', MA: 'ar', DZ: 'ar', TN: 'ar', LY: 'ar', YE: 'ar',
  SY: 'ar', LB: 'ar',
  // Hindi
  IN: 'hi',
  // Neerlandés
  NL: 'nl',
  // Turco
  TR: 'tr',
  // Polaco
  PL: 'pl',
  // Griego
  GR: 'el', CY: 'el',
  // Sueco
  SE: 'sv',
  // Vietnamita
  VN: 'vi',
  // Tailandés
  TH: 'th',
  // Indonesio
  ID: 'id',
  // Ucraniano
  UA: 'uk',
  // Rumano
  RO: 'ro', MD: 'ro',
  // Húngaro
  HU: 'hu',
  // Checo
  CZ: 'cs',
  // Danés
  DK: 'da',
  // Noruego
  NO: 'no',
  // Finlandés
  FI: 'fi',
  // Hebreo
  IL: 'he',
  // Persa
  IR: 'fa',
  // Urdu
  PK: 'ur',
  // Bengalí
  BD: 'bn',
  // Malayo
  MY: 'ms',
  // Filipino
  PH: 'tl',
  // Swahili
  KE: 'sw', TZ: 'sw', UG: 'sw',
  // Búlgaro
  BG: 'bg',
  // Catalán
  AD: 'ca',
  // Eslovaco
  SK: 'sk',
  // Esloveno
  SI: 'sl',
  // Serbio
  RS: 'sr',
  // Croata
  HR: 'hr',
  // Lituano
  LT: 'lt',
  // Letón
  LV: 'lv',
  // Estonio
  EE: 'et',
  // Islandés
  IS: 'is',
  // Albanés
  AL: 'sq',
  // Georgiano
  GE: 'ka',
  // Armenio
  AM: 'hy',
  // Azerí
  AZ: 'az',
  // Kazajo
  KZ: 'kk',
  // Mongol
  MN: 'mn',
  // Nepalí
  NP: 'ne',
  // Cingalés
  LK: 'si',
  // Jemer
  KH: 'km',
  // Lao
  LA: 'lo',
  // Birmano
  MM: 'my',
  // Somalí
  SO: 'so',
  // Amárico
  ET: 'am',
  // Criollo haitiano
  HT: 'ht',
  // Irlandés (queda GB/IE en inglés arriba, no se pisa)
  // Euskera/Gallego no tienen país propio, sin entrada acá.
};

export const getLanguageForCountryCode = (countryCode) =>
  COUNTRY_LANGUAGE_MAP[(countryCode || '').toUpperCase()] || null;
